import styled, { css, keyframes } from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const Option = styled.div<{
  isLastOption?: boolean;
  isFirstOption?: boolean;
  isDisabled?: boolean;
  suppressOptionTopBorder?: boolean;
  isMRO?: boolean;
}>(
  ({
    theme,
    isFirstOption,
    isLastOption,
    isDisabled,
    suppressOptionTopBorder,
    isMRO,
  }) => ({
    background: theme.colors[theme.colorMode].background_Primary,
    padding: `${theme.spacing.medium} ${isMRO ? theme.spacing.large : theme.spacing.medium} ${theme.spacing.medium} ${theme.spacing.large}`,
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    borderTop: `1px solid ${isMRO ? theme.colors[theme.colorMode].background_Disabled : theme.colors[theme.colorMode].border_Tertiary }`,
    outline: "none",
    flexWrap: "wrap",

    ...(isFirstOption && {
        borderTop: "none",
    }),

    ...(suppressOptionTopBorder && {
        borderTop: "none",
        ...(!isLastOption && { paddingBottom: 0 }),
    }),

    ...(isLastOption && {
        borderBottomLeftRadius: theme.cornerRadius.medium,
        borderBottomRightRadius: theme.cornerRadius.medium,
        padding: `${theme.spacing.medium} ${isMRO ? theme.spacing.large : theme.spacing.medium} ${theme.spacing.small} ${theme.spacing.large}`,
    }),

    ...(isDisabled && {
        opacity: 0.7,
    }),
}));

export const Flex = styled.div(() => ({
    display: "flex",
    alignItems: "center",
}));

export const Wrapper = styled.div<{ isLastOption?: boolean; isFirstOption?: boolean }>(({ theme }) => ({
    ".custom-checkbox": {
        left: "19px",
        top: `calc(${theme.spacing.medium} + 1px)`, // 1px is added to align the checkbox with the text
        padding: 0,
    },
}));

export const TextDivider = styled(Text)(({ theme }) => ({
    margin: `0 ${theme.spacing.xxSmall}`,
}));

export const InfoWrapper = styled.div<{ topMarginRequired?: boolean }>(({ theme, topMarginRequired }) => ({
    flex: 1,
    marginLeft: `calc(${theme.spacing.medium} + ${theme.spacing.small})`, //Added medium for Radio button & small for padding from radio button

    ...(topMarginRequired && {
        marginTop: theme.spacing.xxxSmall,
    }),
}));

export const DeliveryOptionHeaderContainer = styled.div(() => ({
    display: "flex",
    justifyContent: "space-between",
}));

export const TextNoWrap = styled(Text)(() => ({
    whiteSpace: "nowrap",
}));

export const Sla = styled(TextNoWrap)(() => ({
    marginTop: "1px",
}));

export const ExpressIconWrapper = styled.div`
    position: relative;
    left: 1px;
    top: 3px;
`;

const gradientShimmer = keyframes`
    100% {
        mask-position: left;
  }
`;

export const BannerWrapper = styled.div<{ bgColor: string }>(
    ({ theme, bgColor }) => ({
        position: "relative",
        zIndex: 2,
        flexBasis: "100%",
        marginLeft: `calc(${theme.spacing.medium} + ${theme.spacing.small})`,
        marginTop: theme.spacing.xSmall,
        marginRight: theme.spacing.medium,
        padding: `${theme.spacing.xSmall}`,
        borderRadius: `40px`,
        background: `linear-gradient(90deg, ${bgColor} 12.4%, #FFFFFF 65.65%)`,
        display: "flex",
        alignItems: "center",
        gap: `${theme.spacing.xxSmall}`,
        mask: "linear-gradient(-70deg,#000 40%,#0003,#000 60%) right/350% 100%",
    }),
    css`
        animation: ${gradientShimmer} 2.5s forwards linear;
    `,
);

export const IconWrapper = styled.div(() => ({
    display: "flex",
    alignItems: "start",
    justifyContent: "start",
}));

export const SlaCommsWrapper = styled.div`
    padding: ${({ theme }) => `${theme.spacing.small} ${theme.spacing.small} 0`};
`;
